/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendCreditDto } from '../models/backend-credit-dto';
import { BackendCreditVariantDto } from '../models/backend-credit-variant-dto';
import { financingSourcesCapexVarinatsRetrieve } from '../fn/credits/financing-sources-capex-varinats-retrieve';
import { FinancingSourcesCapexVarinatsRetrieve$Params } from '../fn/credits/financing-sources-capex-varinats-retrieve';
import { financingSourcesCreditsCopyCreate } from '../fn/credits/financing-sources-credits-copy-create';
import { FinancingSourcesCreditsCopyCreate$Params } from '../fn/credits/financing-sources-credits-copy-create';
import { financingSourcesCreditsCreate } from '../fn/credits/financing-sources-credits-create';
import { financingSourcesCreditsCreate$FormData } from '../fn/credits/financing-sources-credits-create-form-data';
import { FinancingSourcesCreditsCreate$FormData$Params } from '../fn/credits/financing-sources-credits-create-form-data';
import { FinancingSourcesCreditsCreate$Params } from '../fn/credits/financing-sources-credits-create';
import { financingSourcesCreditsCreate$XWwwFormUrlencoded } from '../fn/credits/financing-sources-credits-create-x-www-form-urlencoded';
import { FinancingSourcesCreditsCreate$XWwwFormUrlencoded$Params } from '../fn/credits/financing-sources-credits-create-x-www-form-urlencoded';
import { financingSourcesCreditsDestroy } from '../fn/credits/financing-sources-credits-destroy';
import { FinancingSourcesCreditsDestroy$Params } from '../fn/credits/financing-sources-credits-destroy';
import { financingSourcesCreditsEnumsRetrieve } from '../fn/credits/financing-sources-credits-enums-retrieve';
import { FinancingSourcesCreditsEnumsRetrieve$Params } from '../fn/credits/financing-sources-credits-enums-retrieve';
import { financingSourcesCreditsList } from '../fn/credits/financing-sources-credits-list';
import { FinancingSourcesCreditsList$Params } from '../fn/credits/financing-sources-credits-list';
import { financingSourcesCreditsPartialUpdate } from '../fn/credits/financing-sources-credits-partial-update';
import { financingSourcesCreditsPartialUpdate$FormData } from '../fn/credits/financing-sources-credits-partial-update-form-data';
import { FinancingSourcesCreditsPartialUpdate$FormData$Params } from '../fn/credits/financing-sources-credits-partial-update-form-data';
import { FinancingSourcesCreditsPartialUpdate$Params } from '../fn/credits/financing-sources-credits-partial-update';
import { financingSourcesCreditsPartialUpdate$XWwwFormUrlencoded } from '../fn/credits/financing-sources-credits-partial-update-x-www-form-urlencoded';
import { FinancingSourcesCreditsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/credits/financing-sources-credits-partial-update-x-www-form-urlencoded';
import { financingSourcesCreditsRetrieve } from '../fn/credits/financing-sources-credits-retrieve';
import { FinancingSourcesCreditsRetrieve$Params } from '../fn/credits/financing-sources-credits-retrieve';
import { financingSourcesCreditsUpdate } from '../fn/credits/financing-sources-credits-update';
import { financingSourcesCreditsUpdate$FormData } from '../fn/credits/financing-sources-credits-update-form-data';
import { FinancingSourcesCreditsUpdate$FormData$Params } from '../fn/credits/financing-sources-credits-update-form-data';
import { FinancingSourcesCreditsUpdate$Params } from '../fn/credits/financing-sources-credits-update';
import { financingSourcesCreditsUpdate$XWwwFormUrlencoded } from '../fn/credits/financing-sources-credits-update-x-www-form-urlencoded';
import { FinancingSourcesCreditsUpdate$XWwwFormUrlencoded$Params } from '../fn/credits/financing-sources-credits-update-x-www-form-urlencoded';
import { financingSourcesCreditsVariantsCopyCreate } from '../fn/credits/financing-sources-credits-variants-copy-create';
import { FinancingSourcesCreditsVariantsCopyCreate$Params } from '../fn/credits/financing-sources-credits-variants-copy-create';
import { financingSourcesCreditsVariantsCreate } from '../fn/credits/financing-sources-credits-variants-create';
import { financingSourcesCreditsVariantsCreate$FormData } from '../fn/credits/financing-sources-credits-variants-create-form-data';
import { FinancingSourcesCreditsVariantsCreate$FormData$Params } from '../fn/credits/financing-sources-credits-variants-create-form-data';
import { FinancingSourcesCreditsVariantsCreate$Params } from '../fn/credits/financing-sources-credits-variants-create';
import { financingSourcesCreditsVariantsCreate$XWwwFormUrlencoded } from '../fn/credits/financing-sources-credits-variants-create-x-www-form-urlencoded';
import { FinancingSourcesCreditsVariantsCreate$XWwwFormUrlencoded$Params } from '../fn/credits/financing-sources-credits-variants-create-x-www-form-urlencoded';
import { financingSourcesCreditsVariantsDestroy } from '../fn/credits/financing-sources-credits-variants-destroy';
import { FinancingSourcesCreditsVariantsDestroy$Params } from '../fn/credits/financing-sources-credits-variants-destroy';
import { financingSourcesCreditsVariantsList } from '../fn/credits/financing-sources-credits-variants-list';
import { FinancingSourcesCreditsVariantsList$Params } from '../fn/credits/financing-sources-credits-variants-list';
import { financingSourcesCreditsVariantsPartialUpdate } from '../fn/credits/financing-sources-credits-variants-partial-update';
import { financingSourcesCreditsVariantsPartialUpdate$FormData } from '../fn/credits/financing-sources-credits-variants-partial-update-form-data';
import { FinancingSourcesCreditsVariantsPartialUpdate$FormData$Params } from '../fn/credits/financing-sources-credits-variants-partial-update-form-data';
import { FinancingSourcesCreditsVariantsPartialUpdate$Params } from '../fn/credits/financing-sources-credits-variants-partial-update';
import { financingSourcesCreditsVariantsPartialUpdate$XWwwFormUrlencoded } from '../fn/credits/financing-sources-credits-variants-partial-update-x-www-form-urlencoded';
import { FinancingSourcesCreditsVariantsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/credits/financing-sources-credits-variants-partial-update-x-www-form-urlencoded';
import { financingSourcesCreditsVariantsRetrieve } from '../fn/credits/financing-sources-credits-variants-retrieve';
import { FinancingSourcesCreditsVariantsRetrieve$Params } from '../fn/credits/financing-sources-credits-variants-retrieve';
import { financingSourcesCreditsVariantsUpdate } from '../fn/credits/financing-sources-credits-variants-update';
import { financingSourcesCreditsVariantsUpdate$FormData } from '../fn/credits/financing-sources-credits-variants-update-form-data';
import { FinancingSourcesCreditsVariantsUpdate$FormData$Params } from '../fn/credits/financing-sources-credits-variants-update-form-data';
import { FinancingSourcesCreditsVariantsUpdate$Params } from '../fn/credits/financing-sources-credits-variants-update';
import { financingSourcesCreditsVariantsUpdate$XWwwFormUrlencoded } from '../fn/credits/financing-sources-credits-variants-update-x-www-form-urlencoded';
import { FinancingSourcesCreditsVariantsUpdate$XWwwFormUrlencoded$Params } from '../fn/credits/financing-sources-credits-variants-update-x-www-form-urlencoded';
import { financingSourcesUnblockCreditsVariantsCreate } from '../fn/credits/financing-sources-unblock-credits-variants-create';
import { financingSourcesUnblockCreditsVariantsCreate$FormData } from '../fn/credits/financing-sources-unblock-credits-variants-create-form-data';
import { FinancingSourcesUnblockCreditsVariantsCreate$FormData$Params } from '../fn/credits/financing-sources-unblock-credits-variants-create-form-data';
import { FinancingSourcesUnblockCreditsVariantsCreate$Params } from '../fn/credits/financing-sources-unblock-credits-variants-create';
import { financingSourcesUnblockCreditsVariantsCreate$XWwwFormUrlencoded } from '../fn/credits/financing-sources-unblock-credits-variants-create-x-www-form-urlencoded';
import { FinancingSourcesUnblockCreditsVariantsCreate$XWwwFormUrlencoded$Params } from '../fn/credits/financing-sources-unblock-credits-variants-create-x-www-form-urlencoded';
import { BackendIdDto } from '../models/backend-id-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiCreditsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `financingSourcesCapexVarinatsRetrieve()` */
  static readonly FinancingSourcesCapexVarinatsRetrievePath = '/api/financing_sources/capex_varinats/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCapexVarinatsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesCapexVarinatsRetrieve$Response(
    params: FinancingSourcesCapexVarinatsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return financingSourcesCapexVarinatsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCapexVarinatsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesCapexVarinatsRetrieve(
    params: FinancingSourcesCapexVarinatsRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.financingSourcesCapexVarinatsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `financingSourcesCreditsList()` */
  static readonly FinancingSourcesCreditsListPath = '/api/financing_sources/credits/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesCreditsList$Response(
    params?: FinancingSourcesCreditsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendCreditDto>>> {
    return financingSourcesCreditsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesCreditsList(
    params?: FinancingSourcesCreditsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendCreditDto>> {
    return this.financingSourcesCreditsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendCreditDto>>): Array<BackendCreditDto> => r.body),
    );
  }

  /** Path part for operation `financingSourcesCreditsCreate()` */
  static readonly FinancingSourcesCreditsCreatePath = '/api/financing_sources/credits/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesCreditsCreate$Response(
    params: FinancingSourcesCreditsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCreditDto>> {
    return financingSourcesCreditsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesCreditsCreate(
    params: FinancingSourcesCreditsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendCreditDto> {
    return this.financingSourcesCreditsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCreditDto>): BackendCreditDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesCreditsCreate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesCreditsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCreditDto>> {
    return financingSourcesCreditsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesCreditsCreate$XWwwFormUrlencoded(
    params: FinancingSourcesCreditsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendCreditDto> {
    return this.financingSourcesCreditsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCreditDto>): BackendCreditDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesCreditsCreate$FormData$Response(
    params: FinancingSourcesCreditsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCreditDto>> {
    return financingSourcesCreditsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesCreditsCreate$FormData(
    params: FinancingSourcesCreditsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendCreditDto> {
    return this.financingSourcesCreditsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCreditDto>): BackendCreditDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesCreditsRetrieve()` */
  static readonly FinancingSourcesCreditsRetrievePath = '/api/financing_sources/credits/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesCreditsRetrieve$Response(
    params: FinancingSourcesCreditsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCreditDto>> {
    return financingSourcesCreditsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesCreditsRetrieve(
    params: FinancingSourcesCreditsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendCreditDto> {
    return this.financingSourcesCreditsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCreditDto>): BackendCreditDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesCreditsUpdate()` */
  static readonly FinancingSourcesCreditsUpdatePath = '/api/financing_sources/credits/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesCreditsUpdate$Response(
    params: FinancingSourcesCreditsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCreditDto>> {
    return financingSourcesCreditsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesCreditsUpdate(
    params: FinancingSourcesCreditsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendCreditDto> {
    return this.financingSourcesCreditsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCreditDto>): BackendCreditDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesCreditsUpdate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesCreditsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCreditDto>> {
    return financingSourcesCreditsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesCreditsUpdate$XWwwFormUrlencoded(
    params: FinancingSourcesCreditsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendCreditDto> {
    return this.financingSourcesCreditsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCreditDto>): BackendCreditDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesCreditsUpdate$FormData$Response(
    params: FinancingSourcesCreditsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCreditDto>> {
    return financingSourcesCreditsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesCreditsUpdate$FormData(
    params: FinancingSourcesCreditsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendCreditDto> {
    return this.financingSourcesCreditsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCreditDto>): BackendCreditDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesCreditsDestroy()` */
  static readonly FinancingSourcesCreditsDestroyPath = '/api/financing_sources/credits/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesCreditsDestroy$Response(
    params: FinancingSourcesCreditsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return financingSourcesCreditsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesCreditsDestroy(
    params: FinancingSourcesCreditsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.financingSourcesCreditsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `financingSourcesCreditsPartialUpdate()` */
  static readonly FinancingSourcesCreditsPartialUpdatePath = '/api/financing_sources/credits/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesCreditsPartialUpdate$Response(
    params: FinancingSourcesCreditsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCreditDto>> {
    return financingSourcesCreditsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesCreditsPartialUpdate(
    params: FinancingSourcesCreditsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendCreditDto> {
    return this.financingSourcesCreditsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCreditDto>): BackendCreditDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesCreditsPartialUpdate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesCreditsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCreditDto>> {
    return financingSourcesCreditsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesCreditsPartialUpdate$XWwwFormUrlencoded(
    params: FinancingSourcesCreditsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendCreditDto> {
    return this.financingSourcesCreditsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCreditDto>): BackendCreditDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesCreditsPartialUpdate$FormData$Response(
    params: FinancingSourcesCreditsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCreditDto>> {
    return financingSourcesCreditsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesCreditsPartialUpdate$FormData(
    params: FinancingSourcesCreditsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendCreditDto> {
    return this.financingSourcesCreditsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCreditDto>): BackendCreditDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesCreditsCopyCreate()` */
  static readonly FinancingSourcesCreditsCopyCreatePath = '/api/financing_sources/credits/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesCreditsCopyCreate$Response(
    params: FinancingSourcesCreditsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return financingSourcesCreditsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesCreditsCopyCreate(
    params: FinancingSourcesCreditsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.financingSourcesCreditsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `financingSourcesCreditsEnumsRetrieve()` */
  static readonly FinancingSourcesCreditsEnumsRetrievePath = '/api/financing_sources/credits/enums/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsEnumsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesCreditsEnumsRetrieve$Response(
    params: FinancingSourcesCreditsEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return financingSourcesCreditsEnumsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsEnumsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesCreditsEnumsRetrieve(
    params: FinancingSourcesCreditsEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.financingSourcesCreditsEnumsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `financingSourcesCreditsVariantsList()` */
  static readonly FinancingSourcesCreditsVariantsListPath = '/api/financing_sources/credits_variants/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsVariantsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesCreditsVariantsList$Response(
    params?: FinancingSourcesCreditsVariantsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendCreditVariantDto>>> {
    return financingSourcesCreditsVariantsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsVariantsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesCreditsVariantsList(
    params?: FinancingSourcesCreditsVariantsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendCreditVariantDto>> {
    return this.financingSourcesCreditsVariantsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendCreditVariantDto>>): Array<BackendCreditVariantDto> => r.body),
    );
  }

  /** Path part for operation `financingSourcesCreditsVariantsCreate()` */
  static readonly FinancingSourcesCreditsVariantsCreatePath = '/api/financing_sources/credits_variants/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsVariantsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesCreditsVariantsCreate$Response(
    params: FinancingSourcesCreditsVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCreditVariantDto>> {
    return financingSourcesCreditsVariantsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsVariantsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesCreditsVariantsCreate(
    params: FinancingSourcesCreditsVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendCreditVariantDto> {
    return this.financingSourcesCreditsVariantsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCreditVariantDto>): BackendCreditVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsVariantsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesCreditsVariantsCreate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesCreditsVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCreditVariantDto>> {
    return financingSourcesCreditsVariantsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsVariantsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesCreditsVariantsCreate$XWwwFormUrlencoded(
    params: FinancingSourcesCreditsVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendCreditVariantDto> {
    return this.financingSourcesCreditsVariantsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCreditVariantDto>): BackendCreditVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsVariantsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesCreditsVariantsCreate$FormData$Response(
    params: FinancingSourcesCreditsVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCreditVariantDto>> {
    return financingSourcesCreditsVariantsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsVariantsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesCreditsVariantsCreate$FormData(
    params: FinancingSourcesCreditsVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendCreditVariantDto> {
    return this.financingSourcesCreditsVariantsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCreditVariantDto>): BackendCreditVariantDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesCreditsVariantsRetrieve()` */
  static readonly FinancingSourcesCreditsVariantsRetrievePath = '/api/financing_sources/credits_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsVariantsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesCreditsVariantsRetrieve$Response(
    params: FinancingSourcesCreditsVariantsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCreditVariantDto>> {
    return financingSourcesCreditsVariantsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsVariantsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesCreditsVariantsRetrieve(
    params: FinancingSourcesCreditsVariantsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendCreditVariantDto> {
    return this.financingSourcesCreditsVariantsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCreditVariantDto>): BackendCreditVariantDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesCreditsVariantsUpdate()` */
  static readonly FinancingSourcesCreditsVariantsUpdatePath = '/api/financing_sources/credits_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsVariantsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesCreditsVariantsUpdate$Response(
    params: FinancingSourcesCreditsVariantsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCreditVariantDto>> {
    return financingSourcesCreditsVariantsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsVariantsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesCreditsVariantsUpdate(
    params: FinancingSourcesCreditsVariantsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendCreditVariantDto> {
    return this.financingSourcesCreditsVariantsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCreditVariantDto>): BackendCreditVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsVariantsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesCreditsVariantsUpdate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesCreditsVariantsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCreditVariantDto>> {
    return financingSourcesCreditsVariantsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsVariantsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesCreditsVariantsUpdate$XWwwFormUrlencoded(
    params: FinancingSourcesCreditsVariantsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendCreditVariantDto> {
    return this.financingSourcesCreditsVariantsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCreditVariantDto>): BackendCreditVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsVariantsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesCreditsVariantsUpdate$FormData$Response(
    params: FinancingSourcesCreditsVariantsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCreditVariantDto>> {
    return financingSourcesCreditsVariantsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsVariantsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesCreditsVariantsUpdate$FormData(
    params: FinancingSourcesCreditsVariantsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendCreditVariantDto> {
    return this.financingSourcesCreditsVariantsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCreditVariantDto>): BackendCreditVariantDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesCreditsVariantsDestroy()` */
  static readonly FinancingSourcesCreditsVariantsDestroyPath = '/api/financing_sources/credits_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsVariantsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesCreditsVariantsDestroy$Response(
    params: FinancingSourcesCreditsVariantsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return financingSourcesCreditsVariantsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsVariantsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesCreditsVariantsDestroy(
    params: FinancingSourcesCreditsVariantsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.financingSourcesCreditsVariantsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `financingSourcesCreditsVariantsPartialUpdate()` */
  static readonly FinancingSourcesCreditsVariantsPartialUpdatePath = '/api/financing_sources/credits_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsVariantsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesCreditsVariantsPartialUpdate$Response(
    params: FinancingSourcesCreditsVariantsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCreditVariantDto>> {
    return financingSourcesCreditsVariantsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsVariantsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesCreditsVariantsPartialUpdate(
    params: FinancingSourcesCreditsVariantsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendCreditVariantDto> {
    return this.financingSourcesCreditsVariantsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCreditVariantDto>): BackendCreditVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsVariantsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesCreditsVariantsPartialUpdate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesCreditsVariantsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCreditVariantDto>> {
    return financingSourcesCreditsVariantsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsVariantsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesCreditsVariantsPartialUpdate$XWwwFormUrlencoded(
    params: FinancingSourcesCreditsVariantsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendCreditVariantDto> {
    return this.financingSourcesCreditsVariantsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCreditVariantDto>): BackendCreditVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsVariantsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesCreditsVariantsPartialUpdate$FormData$Response(
    params: FinancingSourcesCreditsVariantsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCreditVariantDto>> {
    return financingSourcesCreditsVariantsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsVariantsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesCreditsVariantsPartialUpdate$FormData(
    params: FinancingSourcesCreditsVariantsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendCreditVariantDto> {
    return this.financingSourcesCreditsVariantsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCreditVariantDto>): BackendCreditVariantDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesCreditsVariantsCopyCreate()` */
  static readonly FinancingSourcesCreditsVariantsCopyCreatePath = '/api/financing_sources/credits_variants/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesCreditsVariantsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesCreditsVariantsCopyCreate$Response(
    params: FinancingSourcesCreditsVariantsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return financingSourcesCreditsVariantsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesCreditsVariantsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesCreditsVariantsCopyCreate(
    params: FinancingSourcesCreditsVariantsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.financingSourcesCreditsVariantsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `financingSourcesUnblockCreditsVariantsCreate()` */
  static readonly FinancingSourcesUnblockCreditsVariantsCreatePath = '/api/financing_sources/unblock-credits-variants/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesUnblockCreditsVariantsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesUnblockCreditsVariantsCreate$Response(
    params: FinancingSourcesUnblockCreditsVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return financingSourcesUnblockCreditsVariantsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesUnblockCreditsVariantsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesUnblockCreditsVariantsCreate(
    params: FinancingSourcesUnblockCreditsVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.financingSourcesUnblockCreditsVariantsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesUnblockCreditsVariantsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesUnblockCreditsVariantsCreate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesUnblockCreditsVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return financingSourcesUnblockCreditsVariantsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesUnblockCreditsVariantsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesUnblockCreditsVariantsCreate$XWwwFormUrlencoded(
    params: FinancingSourcesUnblockCreditsVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.financingSourcesUnblockCreditsVariantsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesUnblockCreditsVariantsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesUnblockCreditsVariantsCreate$FormData$Response(
    params: FinancingSourcesUnblockCreditsVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return financingSourcesUnblockCreditsVariantsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesUnblockCreditsVariantsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesUnblockCreditsVariantsCreate$FormData(
    params: FinancingSourcesUnblockCreditsVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.financingSourcesUnblockCreditsVariantsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }
}
